import React, { FunctionComponent, useMemo } from 'react';
import { makeStyles, Box } from '@material-ui/core';

import { ListItem } from '#web-components/types/table';
import Typography from '#web-components/components/Typography';
import InlineButton from '#web-components/components/InlineButton';
import BackLeftIcon from '#web-components/components/Icons/BackLeftIcon/BackLeftIcon';
import ServiceCard from '#web-components/components/ServiceCard';
import { FolderIcon } from '#web-components/components/Icons';

import { EntityItem, EntityGroup } from '#web-components/types/groupedEntity';
import styles from './EntityGroup.styles';

const useStyles = makeStyles(styles, { name: 'EntityGroupComponent' });

export interface EntityGroupComponentProps {
  group: EntityGroup,
  readonly?: boolean,
  backToGroups: () => void,
  emptyPlaceholder: string,
  onEntitySelect?: (item: ListItem) => void,
  existingGroupNames?: string[],
  'data-xpath'?: {
    backToGroups?: string,
  },
  groupTitle?: string,
  GroupActions?: FunctionComponent<{ item: EntityGroup, unselectGroup: () => void }>,
  EntityTableActions?: FunctionComponent<{
    item: ListItem,
    list: Array<EntityItem>,
    groupName?: string,
    existingGroupNames: string[],
    moveToUngroupedEnable?: boolean,
  }>,
}

export default function EntityGroupComponent(props: EntityGroupComponentProps) {
  const {
    group,
    readonly,
    backToGroups,
    emptyPlaceholder,
    existingGroupNames,
    EntityTableActions,
    GroupActions,
    groupTitle,
    onEntitySelect,
    'data-xpath': dataXpath,
  } = props;
  const classes = useStyles(props);

  const list = useMemo(() => group?.entityList || [], [group]);

  return (
    <>
      <Box className={classes.title}>
        <InlineButton
          size="large"
          leftIcon={<BackLeftIcon />}
          onLinkClick={backToGroups}
          data-xpath={dataXpath?.backToGroups}
          oneLine
        >
          {group.name}
        </InlineButton>
        {(!readonly && GroupActions) && (
          <GroupActions item={group} unselectGroup={backToGroups} />
        )}
      </Box>
      {!list.length && (
      <Box display="flex" alignItems="center" flexDirection="column" width="100%">
        <Typography variant="h3" component="span" align="center">
          <span role="img" aria-label="ok"><FolderIcon /></span>
        </Typography>
        <Typography
          variant="textRegular"
          align="center"
        >
          {emptyPlaceholder}
        </Typography>
      </Box>
      )}
      {groupTitle && !!list.length && (
      <Typography className={classes.mb2} variant="textSmallCompact">
        {groupTitle}
      </Typography>
      ) }
      {list.map((item) => (
        <ServiceCard
          className={classes.rowDistance}
          variant="compact"
          key={item.id}
          onClick={() => onEntitySelect && onEntitySelect(item)}
          actions={(
            EntityTableActions && !readonly && (
            <EntityTableActions
              item={item}
              list={group.entityList || []}
              existingGroupNames={existingGroupNames || []}
              groupName={group.name}
              moveToUngroupedEnable
            />
            )
          )}
        >
          {item.name}
        </ServiceCard>
      ))}
    </>
  );
}
